<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-navigation-drawer
                v-model="drawer"
                app
                clipped
                expand-on-hover
        >
            <v-list dense>
                <v-list-item v-for="menu in routers" :key="menu.path" @click="navTo(menu.path)" link>
                    <v-list-item-action>
                        <v-icon>{{menu.meta.icon}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{menu.meta.title}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>

        <v-app-bar
                app
                clipped-left
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
            <v-toolbar-title>超管的地盘</v-toolbar-title>
            <v-spacer></v-spacer>


            <v-switch
                    v-model="dark"
                    color="dark"
                    style="margin-top: 15px"
            ></v-switch>


            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                            icon
                            large
                            v-on="on"
                    >
                        <v-icon>settings</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                            v-for="(item, index) in setUpList"
                            :key="index"
                            @click="clickSetUp(item)"
                    >
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

        </v-app-bar>

        <v-content>
            <transition name="fade-transform" mode="out-in">
                <keep-alive>
                    <router-view/>
                </keep-alive>
            </transition>
        </v-content>

    </div>
</template>

<script>
  import {mapGetters} from 'vuex'


  export default {
    name: 'Layout',
    data: () => ({
      drawer: null,
      dark: true,
      setUpList: [
        // {
        //   label: '修改密码',
        //   id: '01'
        // },
        {
          label: '退出登录',
          id: '00'
        }
      ]
    }),
    created() {
      this.$vuetify.theme.dark = this.dark
    },
    computed: {
      ...mapGetters([
        'routers'
      ]),
    },
    methods: {
      navTo(path) {
        this.$router.push({path: '/admin/' + path})
      },
      loginOut() {
        this.$store.dispatch('logOut').then(() => {
          //location.reload()// In order to re-instantiate the vue-router object to avoid bugs
          this.$router.push({path: '/admin-login'})
          location.reload()
        })
      },
      clickSetUp(item) {
        if (item.id == '00') {
          // 退出登录
          this.loginOut();
        }
      }
    },
    watch: {
      dark: {
        handler(v) {
          this.$vuetify.theme.dark = v
        }
      },
    },
    mounted() {

    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
